import React from "react";
import CountUp from "react-countup";
import isoImage from "../../Assets/Images/iso-business.png";

const BusinessISO = () => {
  const stats = [
    { number: 165, suffix: "K", label: "Happy Customers" },
    { number: 300, suffix: "+", label: "Auditors" },
    { number: 12, suffix: "+", label: "Countries" },
    { number: 150, suffix: "+", label: "Technical Experts" },
  ];

  return (
    <section className="business-iso-section container ">
      <div className="row align-items-center">
        
        {/* Left Side */}
        <div className="col-md-6 mb-4 mb-md-0">
          <div className="iso-image-wrapper">
            <img src={isoImage} alt="ISO Business" className="img-fluid rounded" />
            <div className="iso-badge">
              <span className="iso-badge-number">#1</span>
              <span className="iso-badge-text">Best Award<br />2023</span>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="col-md-6 iso-business-right ps-3">
          <h2 className="mb-3">
            Helping businesses earn trust 
            <span> through Certification standards</span>
          </h2>
          <p className="mb-4">
            We connect businesses and customers through the trust and quality of ISO certification. 
            Our standards help you strengthen relationships and grow with confidence.
          </p>
          <button className="view-reports-button rounded-pill mb-4">View Reports →</button>

          {/* Stats */}
         
        </div>
         <div className="row text-center mt-5">
            {stats.map((item, index) => (
              <div className="col-6 col-md-3 mb-3 iso-stats" key={index}>
                <h3 className="">
                  <CountUp end={item.number} duration={2.5} />{item.suffix}
                </h3>
                <p>{item.label}</p>
              </div>
            ))}
          </div>

      </div>
    </section>
  );
};

export default BusinessISO;
